/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1LayoutexpressionsQueryResponse } from '../../types/GetV1Layoutexpressions.ts'

export const getV1LayoutexpressionsQueryKey = () => [{ url: '/v1/LayoutExpressions' }] as const

export type GetV1LayoutexpressionsQueryKey = ReturnType<typeof getV1LayoutexpressionsQueryKey>

/**
 * {@link /v1/LayoutExpressions}
 */
export async function getV1Layoutexpressions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1LayoutexpressionsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/LayoutExpressions`, ...requestConfig })
    return res
}

export function getV1LayoutexpressionsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1LayoutexpressionsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1LayoutexpressionsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1LayoutexpressionsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Layoutexpressions(config)
        },
    })
}

/**
 * {@link /v1/LayoutExpressions}
 */
export function useGetV1Layoutexpressions<
    TData = ResponseConfig<GetV1LayoutexpressionsQueryResponse>,
    TQueryData = ResponseConfig<GetV1LayoutexpressionsQueryResponse>,
    TQueryKey extends QueryKey = GetV1LayoutexpressionsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1LayoutexpressionsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1LayoutexpressionsQueryKey()

    const query = useQuery(
        {
            ...getV1LayoutexpressionsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
